module.exports = __webpack_public_path__ + "static/media/section3.014eabd7.png";